<template>
  <div class="form-pallet-user">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.palletType')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('forms.inputs.palletType')"
                  v-model="palletUserParams.pallet_type_id"
                  keyBy="id"
                  textBy="name"
                  :options="pallet_types"
                />
              </div>
            </div>

          <div class="row">
            <div class="flex md2 sm6 xs12">
              <va-button
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="create(palletUserParams)"
              >
                {{ $t('menu.add') }}
              </va-button>
            </div>
            <div class="flex md2 sm6 xs12">
              <va-button
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="renderPerfil(palletUserParams)"
                >
                {{ $t('menu.savePerfil') }}
              </va-button>
            </div>
            <div class="flex md2 sm6 xs12">
              <va-button
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="renderLocality(palletUserParams)"
                >
                {{ $t('menu.saveLocality') }}
              </va-button>
            </div>
            <div class="flex md2 sm6 xs12">
              <va-button
                medium
                inline
                color="#ff842b"
                icon="fa fa-chevron-left"
                class="ma-0"
                :to="{ name: 'users', params: {
                  current_page: this.$route.params.current_page, 
                  searchName: this.$route.params.searchName, 
                  perPage: this.$route.params.perPage }
                  }"
              >
                {{ $t('menu.back') }}
              </va-button>
            </div>
          </div>

            <va-data-table
              :fields="fields"
              :data="userPalletTypes"
              no-pagination
            >
              <template slot="actions" slot-scope="props">
                <va-button 
                  small 
                  inline 
                  color="danger" 
                  icon="fa fa-remove"
                  class="ma-0"
                  @click="showModalRemove = true, palletUserId = props.rowData.id" 
                >
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
            </va-data-table>
              <va-modal
                v-model="showModalRemove"
                size="small"
                :title="$t('modal.remove')"
                :message="$t('modal.messageRemovePalletUser')"
                hideDefaultActions
                :color="this.$themes.secondary"
              >
              <va-button
                color="danger"
                class="ma-2"
                @click="showModalRemove = false">
                {{$t('modal.cancel')}}
              </va-button>

              <va-button
                color="secondary"
                class="ma-2"
                @click="remove(palletUserId), showModalRemove = false">
                {{$t('modal.confirm')}}
              </va-button>
            </va-modal>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import PalletUserAPI from '@/services/PalletUserAPI'
import PalletTypeAPI from '@/services/PalletTypeAPI'
import { showError } from '@/global'

export default {
  name: 'form-pallet-user',
  components: {},
  data () {
    return {
      palletUserParams: {
        id: '',
        user_id: '',
        pallet_type_id: '',
      },
      userPalletTypes: [],
      pallet_types: [],
      showModalRemove: false,
    }
  },
  mounted () {

    PalletTypeAPI.getAll().then(response => {
      this.pallet_types = response.data.pallet_types
    })

    this.getAllPalletTypes();
  },
  computed: {
    fields () {
      return [{
        name: 'name',
        title: this.$t('tables.pallet_users.title'),
        width: '20%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
  },
  methods: {
    getAllPalletTypes() {
      this.palletUserParams.user_id = this.$route.params.id
      PalletUserAPI.getAllPalletUserByUser(this.$route.params.id).then(response => {
        this.userPalletTypes = response.data.pallet_users_by_user
      })
    },

    create (palletUserParams) {
      PalletUserAPI.createPalletUser(palletUserParams).then(response => {
        this.getAllPalletTypes();

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
          this.palletUserParams.pallet_type_id = ""
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    renderPerfil (palletUserParams) {
      if(this.palletUserParams.pallet_type_id != "") {
      PalletUserAPI.createPalletUser(palletUserParams).then(response => {

        this.showToast(response.data.message + ` e redirecionado`, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        }),
        this.$router.push({name: 'form-role-user', params: { id: this.$route.params.id }})
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      } else {
        this.showToast(`Redirecionado`, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        }),
        this.$router.push({name: 'form-role-user', params: { id: this.$route.params.id }})
      }
    },
    renderLocality (palletUserParams) {
      if(this.palletUserParams.pallet_type_id != "") {
      PalletUserAPI.createPalletUser(palletUserParams).then(response => {

        this.showToast(response.data.message + ` e redirecionado`, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        }),
        this.$router.push({name: 'form-user-locality', params: { id: this.$route.params.id }})
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      } else {
        this.showToast(`Redirecionado`, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        }),
        this.$router.push({name: 'form-user-locality', params: { id: this.$route.params.id }})
      }
    },
    remove (palletUserId) {

      PalletUserAPI.removePalletUser(palletUserId).then(response => {
        const rowItem = this.userPalletTypes.map((e) => e.id).indexOf(palletUserId)
          this.userPalletTypes.splice(rowItem, 1)

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    }
  }
}
</script>